import React, { useState, useEffect, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { Grid, Select, MenuItem, FormControl, InputLabel, TextField, FormControlLabel, RadioGroup, Radio, Button, Tooltip, FormLabel } from '@mui/material'
import moment from 'moment/moment'
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd"
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { Model } from '../../models/model'
import { Link } from 'react-router-dom'
import { Tasks } from '../../models/tasks'
/* import { DialogFormTaskSubs } from './DialogFormTaskSubs' */
import NumberFormat from 'react-number-format'

const statusList = [
    { id: 'por hacer', nombre: 'por hacer' },
    { id: 'en proceso', nombre: 'en proceso' },
    { id: 'completado', nombre: 'completado' },
    { id: 'stand-by', nombre: 'stand-by' }
]

const priorityList = [
    { id: 'critica', nombre: 'crítica' },
    { id: 'alta', nombre: 'alta' },
    { id: 'media', nombre: 'media' },
    { id: 'baja', nombre: 'baja' }

]

const handleUpdateNroOrder = (list) => {
    let count = 0
    const newList = list.map(it => {
        count++
        return {
            ...it,
            orden: count
        }
    })

    return newList
}

const reorder = (list, startIndex, endIndex) => {
    const result = [...list];
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    const result2 = handleUpdateNroOrder(result)
    return result2;
};

export const SeccionGeneralSubs = ({ modeEdit = "", form, setForm, handleChange, handleChangeDate, handleSubmit, handleInitGetTasks }) => {

    const { usuariosTarea } = useSelector(state => state.general)
   /*  const [openDialogFormTaskSubs, setOpenDialogFormTaskSubs] = useState(false) */
    const [idTaskSubsSelect, setIdTaskSubsSelect] = useState(0)


    /*  console.log('--check check check--', form) */

    const handleChangeDateIni = (newValue) => {
        const newData = {
            fecha_inicio: newValue,
            fecha_fin: newValue
        }

        handleChangeDate(newData)
    }

    const handleChangeDateFin = (newValue) => {

        const newData = {
            fecha_inicio: form.fecha_inicio,
            fecha_fin: newValue
        }

        /* setForm((previuos) => {
            handleChangeDate(newData)
        })
 */

        handleChangeDate(newData)

    }

    const handleChangeDias = async (values) => {
        if (!values.sourceInfo.event) return false

        const cantDias = values.floatValue > 1 ? (values.floatValue - 1) : 0
        const newEndDate = moment(form.fecha_inicio).add(cantDias, 'days').format('YYYY-MM-DD')

        setForm({
            ...form,
            dias: values.floatValue,
            fecha_fin: newEndDate
        })

    }

    const handleOpenEditSubs = (id) => {
        console.log(idTaskSubsSelect)
        setIdTaskSubsSelect(id)
        /* setOpenDialogFormTaskSubs(true) */
    }

    /* const handleGetTask2 = async () => {
        if (parseFloat(form?.id) > 0) {
            const resultTask = await Model.getOne({ url: `tasks/${form?.id}` })
            setForm(resultTask)
        }
    } */

    return (
        <div style={{ marginTop: '40px' }}>
            <Grid container spacing='15' columnSpacing='10' alignItems='center' direction='row'>

                <Grid item xs={12}>
                    <h3 style={{ fontSize: '16px' }}>
                        {form?.tipo === 'task' ? 'TAREA:' : 'SUBTAREA:'}{' '}{form?.nombre}
                    </h3>
                </Grid>

                {form?.id > 0 ?
                    <Grid item xs={2}>
                        <div className='p-task-text-name'>
                            <TextField
                                label="Orden"
                                name="orden"
                                id="outlined-size-small"
                                value={form?.orden || ''}
                                size="small"
                                fullWidth
                                onChange={handleChange}
                            />
                        </div>
                    </Grid> : ''
                }

                <Grid item xs={form?.id > 0 ? 10 : 12}>
                    <div className='p-task-text-name'>
                        <TextField
                            label={
                                form?.tipo === 'hito' ?
                                    'Nombre del hito (*)'
                                    :
                                    form?.tipo === 'task' ? 'Nombre de la tarea (*)' : 'Nombre de la subtarea (*)'
                            }
                            name="nombre"
                            id="outlined-size-small"
                            value={form?.nombre || ''}
                            size="small"
                            fullWidth
                            placeholder='Ingrese nombre tarea'
                            onChange={handleChange}
                        />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        id="outlined-multiline-static"
                        name="descripcion"
                        label="Descripción"
                        multiline
                        rows={2}
                        value={form?.descripcion || ''}
                        onChange={handleChange}
                    />
                </Grid>

                {form?.tipo !== 'hito' &&
                    <>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="demo-simple-select-label">Responsable</InputLabel>
                                <Select
                                    label="Responsable"
                                    id="id_responsable"
                                    name="id_responsable"
                                    value={form?.id_responsable || ''}
                                    onChange={handleChange}
                                    className='p-list-capitalize'
                                >
                                    <MenuItem value={null} key={null}>Ninguno</MenuItem>
                                    {usuariosTarea?.map(item => (
                                        <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>
                                            {item.nombre}{' '}{item.apellidos}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="demo-simple-select-label">Seguimiento</InputLabel>
                                <Select
                                    label="Seguimiento"
                                    id="id_responsable_seguimiento"
                                    name="id_responsable_seguimiento"
                                    value={form?.id_responsable_seguimiento || ''}
                                    onChange={handleChange}
                                    className='p-list-capitalize'
                                >
                                    <MenuItem value={null} key={null}>Ninguno</MenuItem>
                                    {usuariosTarea?.map(item => (
                                        <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>
                                            {item.nombre}{' '}{item.apellidos}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </>
                }

                <Grid item xs={12} sm={2}>
                    <NumberFormat
                        className="text-end p-cantidades-item-new22"
                        style={{ backgroundColor: 'white', width: '80px' }}
                        name="dias"
                        value={form?.dias || 0}
                        thousandSeparator=','
                        decimalSeparator='.'
                        suffix=" días"
                        decimalScale={0}
                        fixedDecimalScale={0}
                        onValueChange={(values, sourceInfo) => handleChangeDias({ ...values, sourceInfo })}
                    />
                </Grid>
                <Grid item xs={12} sm={5}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                            label="Fecha inicio"
                            inputFormat="DD/MM/YYYY"
                            name="fecha_inicio"
                            value={form?.fecha_inicio}
                            onChange={handleChangeDateIni}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={12} sm={5}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                            label="Fecha fin"
                            inputFormat="DD/MM/YYYY"
                            name="fecha_fin"
                            value={form?.fecha_fin}
                            onChange={handleChangeDateFin}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                    </LocalizationProvider>
                </Grid>

                {/* {(isDifferent && form?.tipo === 'subtask' && form?.id > 0) ? */}
                {(form?.tipo === 'subtask' && form?.id > 0) ?
                    <Grid item xs={12} style={{ backgroundColor: '#FCF1FF', margin: '10px 0 10px 10px', borderRadius: '5px' }}>
                        <FormControl>
                            <FormLabel id="demo-radio-buttons-group-label">Cambiar fecha para:</FormLabel>
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="date_change_option"
                                onChange={handleChange}
                            >
                                <FormControlLabel
                                    value="esta_tarea"
                                    control={<Radio style={{ color: '#8E24AA' }} checked={form?.date_change_option === 'esta_tarea' ? true : false} />}
                                    label="Esta tarea"
                                />
                                <FormControlLabel
                                    value="esta_tarea_posteriores"
                                    control={<Radio style={{ color: '#8E24AA' }} checked={form?.date_change_option === 'esta_tarea_posteriores' ? true : false} />}
                                    label="Esta tarea y los posteriores"
                                />
                            </RadioGroup>
                        </FormControl>
                    </Grid> : ''
                }

                {form?.tipo !== 'hito' &&
                    <>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="demo-simple-select-label">Estado</InputLabel>
                                <Select
                                    label="Estado"
                                    id="estado"
                                    name="estado"
                                    value={form?.estado || ''}
                                    onChange={handleChange}
                                    style={{ textTransform: 'uppercase' }}
                                >
                                    <MenuItem value='' key=''>Ninguno</MenuItem>
                                    {statusList.map(item => (
                                        <MenuItem value={item.id} key={item.id} style={{ textTransform: 'uppercase' }}>{item.nombre}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="demo-simple-select-label">Prioridad</InputLabel>
                                <Select
                                    label="Prioridad"
                                    id="prioridad"
                                    name="prioridad"
                                    value={form?.prioridad || ''}
                                    onChange={handleChange}
                                    style={{ textTransform: 'uppercase' }}
                                >
                                    <MenuItem value='' key=''>Ninguno</MenuItem>
                                    {priorityList?.map(item => (
                                        <MenuItem value={item.id} key={item.id} style={{ textTransform: 'uppercase' }}>{item.nombre}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </>
                }

                <Grid item xs={12} className="text-end">
                    <Button
                        className='p-btn-primary'
                        variant="contained"
                        size='medium'
                        type='button'
                        onClick={handleSubmit}
                    >
                        Guardar
                    </Button>
                    <hr />
                </Grid>

                {/*  {openDialogFormTaskSubs &&
                    <DialogFormTaskSubs
                        open={openDialogFormTaskSubs}
                        setOpen={setOpenDialogFormTaskSubs}
                        taskId={idTaskSubsSelect || 0}
                        refreshObj={
                            {
                                fn_: handleGetTask2,
                                filters_: null
                            }
                        }
                    />
                } */}

                {(form?.id > 0 && form?.tipo === 'hito') ?
                    <Grid item xs={12}>
                        <BoxTaskList
                            id_tarea={form.id}
                            dataTask={form}
                            handleOpenEditSubs={handleOpenEditSubs}
                        />
                        <hr />
                    </Grid> : ''
                }

                {(form?.id > 0 && form?.tipo === 'task') ?
                    <Grid item xs={12}>
                        <BoxSubTaskList
                            id_tarea={form.id}
                            dataTask={form}
                            handleOpenEditSubs={handleOpenEditSubs}
                        />
                        <hr />
                    </Grid> : ''
                }

                {(form?.id > 0 && form?.tipo !== 'hito') ?
                    <Grid item xs={12}>
                        <BoxCommentsTask
                            id_tarea={form.id}
                            dataTask={form}
                            handleInitGetTasks={handleInitGetTasks}
                        />
                    </Grid> : ''
                }

            </Grid>
        </div>
    )
}

const BoxTaskList = ({ id_tarea, dataTask, handleOpenEditSubs }) => {
    const [newSubs, setNewSubs] = useState('')
    const [tasksListByHito, setTasksListByHito] = useState(dataTask.subs || [])

    useEffect(() => {
        setTasksListByHito(dataTask.subs)
    }, [dataTask.subs])

    // const handleGetTask = async () => {
    //     const resultTask = await Model.getOne({ url: `tasks/${id_tarea}` })
    //     setTasksListByHito(resultTask.subs)
    // }

    const handleAdd = async () => {
        if (newSubs !== '') {
            const newId = (tasksListByHito?.length || 0) + 1
            setTasksListByHito([
                ...tasksListByHito,
                { id: newId, nombre: newSubs }
            ])

            setNewSubs('')

            await Model.save({
                url: 'tasks',
                dataForm: {
                    nombre: newSubs,
                    tipo: 'task',
                    type: 'task',
                    origen: dataTask?.origen,
                    id_origen: dataTask?.id_origen || null,
                    id_hito: id_tarea || null
                },
                resultData: false
            })

        }
    }

    const handleChange = ({ target }) => {
        console.log({ target })
        setNewSubs(target.value)
    }

    const handleEditSubs = (id) => {
        console.log({ id })
    }

    return (
        <div className='p-comment-block'>
            <h5 style={{ fontSize: '16px' }} className='d-flex justify-content-start align-items-center'>
                <i className="bi bi-list-check"></i>
                <span className='ms-2'>Tareas {`${tasksListByHito?.length || 0}`}</span>
            </h5>
            <form>
                <div className='p-comment-block-list pt-1'>
                    {tasksListByHito?.map(it => (
                        <div key={it.id}
                            className='p-comment-one d-flex justify-content-start align-items-center mt-2 ms-4'
                        >
                            <input
                                type="checkbox"
                                style={{
                                    padding: '15px',
                                    width: '20px',
                                    height: '20px',
                                    cursor: 'pointer'
                                }}
                            />
                            <p className='ms-2 w-100'>{it.nombre}</p>
                            <div className="dropdown ms-2">
                                <Link
                                    className="btn dropdown-toggle"
                                    to=""
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"></Link>
                                <ul className="dropdown-menu">
                                    <li><Link className="dropdown-item" to="#" onClick={() => handleOpenEditSubs(it.id)}>Modificar</Link></li>
                                    <li><Link className="dropdown-item" to="#" onClick={() => handleEditSubs(it.id)}>Eliminar</Link></li>
                                </ul>
                            </div>
                        </div>
                    ))}

                    <div
                        className='p-comment-one d-flex justify-content-start align-items-center mt-3'
                        style={{ marginLeft: '40px' }}
                    >
                        <textarea
                            className='text-area-resize ms-2 w-100'
                            name="newsubs"
                            value={newSubs}
                            placeholder='Agregar tarea...'
                            onChange={handleChange}
                            rows="1"
                            style={{
                                border: '1px solid lightgray',
                                padding: '5px',
                            }}
                        >
                        </textarea>
                        <button
                            className='btn ms-1'
                            type='button'
                            onClick={handleAdd}
                        >Agregar</button>
                    </div>

                </div>
            </form>
        </div>
    )
}

const BoxSubTaskList = ({ id_tarea, dataTask, handleOpenEditSubs }) => {
    const [newSubs, setNewSubs] = useState('')
    const [subtasksList, setSubtasksList] = useState(dataTask?.subs)

    useEffect(() => {
        setSubtasksList(dataTask.subs)
    }, [dataTask.subs])

    const handleGetSubsTask = async (taskId = id_tarea) => {
        const resultTask = await Model.getOne({ url: `tasks/${taskId}` })
        setSubtasksList(resultTask.subs)
    }

    const handleAdd = async () => {
        if (newSubs !== '') {
            const newId = (subtasksList?.length || 0) + 1
            setSubtasksList([
                ...subtasksList,
                { id: newId, nombre: newSubs }
            ])

            await Model.save({
                url: 'tasks',
                dataForm: {
                    nombre: newSubs,
                    tipo: 'subtask',
                    type: 'subtask',
                    origen: 'ppto',
                    id_origen: dataTask?.id_origen || null,
                    id_tarea: id_tarea || null
                },
                resultData: false
            })

            setNewSubs('')
            await handleGetSubsTask(id_tarea)

        }
    }

    const handleChange = ({ target }) => {
        console.log({ target })
        setNewSubs(target.value)
    }

    const handleEditSubs = (id) => {
        console.log({ id })
    }

    const handleDragEndSubs = async (result) => {
        const { source, destination } = result

        if (!destination) {
            return;
        }

        if (
            source.index === destination.index &&
            source.droppableId === destination.droppableId
        ) {
            return;
        }

        const tasksListOrdered = reorder(subtasksList, source.index, destination.index)
        setSubtasksList(tasksListOrdered);

        const newForm = {
            ...dataTask,
            tasks_new_order: tasksListOrdered
        }

        await Model.update({
            url: `tasks/update-order/${dataTask.id}`,
            dataForm: newForm
        })

    }

    const handleChangeStatus = async ({ target }, item) => {

        const newForm = {
            ...item,
            [target.name]: target.checked === true ? 'completado' : 'por hacer'
        }

        await Tasks.update(newForm)
        await handleGetSubsTask(item.id_tarea)

    }

    return (
        <DragDropContext onDragEnd={handleDragEndSubs}>
            <Droppable droppableId="tasks-drag-v1">
                {(droppableProvidersubs) => (
                    <div
                        {...droppableProvidersubs.droppableProps}
                        ref={droppableProvidersubs.innerRef}
                        className='p-comment-block'>
                        <h5 style={{ fontSize: '16px' }} className='d-flex justify-content-start align-items-center'>
                            <i className="bi bi-list-check"></i>
                            <span className='ms-2'>Subtareas {`${subtasksList?.length || 0}`}</span>
                        </h5>
                        <form>
                            <div className='p-comment-block-list pt-1'>
                                {subtasksList?.map((it, index) => (
                                    <Draggable key={it.id} draggableId={it.id} index={index}>
                                        {(draggableProvidedSubs) => (
                                            <div
                                                {...draggableProvidedSubs.draggableProps}
                                                ref={draggableProvidedSubs.innerRef}
                                                {...draggableProvidedSubs.dragHandleProps}
                                                className='p-comment-one d-flex justify-content-start align-items-center mt-2 ms-4 task-item'
                                            >
                                                <input
                                                    type="checkbox"
                                                    name="estado"
                                                    checked={it.estado === 'completado' ? true : false}
                                                    style={{
                                                        padding: '15px',
                                                        width: '20px',
                                                        height: '20px',
                                                        cursor: 'pointer'
                                                    }}
                                                    onChange={(e) => handleChangeStatus(e, it)}
                                                />
                                                <p
                                                    className="ms-2 w-100"
                                                    style={{
                                                        fontSize: '13px',
                                                        // color: '#6610f2',
                                                        textAlign: 'left',
                                                        color: it.estado === 'completado' ? 'green' : '',
                                                        textDecoration: it.estado === 'completado' ? 'line-through' : '',
                                                    }}>
                                                    ({it.orden}){' '}{it.nombre}
                                                </p>
                                                <div className="dropdown ms-2">
                                                    <Link
                                                        className="btn dropdown-toggle"
                                                        to=""
                                                        role="button"
                                                        data-bs-toggle="dropdown"
                                                        aria-expanded="false"></Link>
                                                    <ul className="dropdown-menu">
                                                        <li><Link className="dropdown-item" to="#" onClick={() => handleOpenEditSubs(it.id)}>Modificar</Link></li>
                                                        <li><Link className="dropdown-item" to="#" onClick={() => handleEditSubs(it.id)}>Eliminar</Link></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {droppableProvidersubs.placeholder}

                                <div
                                    className='p-comment-one d-flex justify-content-start align-items-center mt-3'
                                    style={{ marginLeft: '40px' }}
                                >
                                    <textarea
                                        className='text-area-resize ms-2 w-100'
                                        name="newsubs"
                                        value={newSubs}
                                        placeholder='Agregar subtarea...'
                                        onChange={handleChange}
                                        rows="1"
                                        style={{
                                            border: '1px solid lightgray',
                                            padding: '5px',
                                        }}
                                    >
                                    </textarea>
                                    <button
                                        className='btn ms-1'
                                        type='button'
                                        onClick={handleAdd}
                                    >Agregar</button>
                                </div>

                            </div>
                        </form>
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    )
}

const BoxCommentsTask = ({ id_tarea, dataTask, handleInitGetTasks }) => {

    const [newComment, setNewComment] = useState('')
    const [commentsList, setCommentsList] = useState([])

    const getCommments = useCallback(async () => {
        const resultComments = await Model.getAll({
            url: `tasks/comments/${id_tarea}`
        })

        setCommentsList(resultComments)
    }, [id_tarea])

    const handleNewComments = async (e) => {
        e.preventDefault()
        setNewComment('')
        await Model.save({
            url: 'tasks/comments',
            dataForm: {
                comentario: newComment,
                id_tarea: id_tarea
            },
            resultData: false
        })

        await getCommments()

        if (handleInitGetTasks) {
            await handleInitGetTasks({
                id_ppto: dataTask?.id_origen,
                view: 'list'
            })
        }

    }

    const handleRemoveComments = async (commentId) => {
        const listUpdated = commentsList?.filter(it => it.id !== commentId)
        setCommentsList(listUpdated)

        if (commentId) {
            await Model.delete({
                url: `tasks/comments/${commentId}`
            })
        }

    }

    useEffect(() => {
        getCommments()
    }, [getCommments])

    return (
        <div className='p-comment-block'>
            <h5 style={{ fontSize: '16px' }}>
                <i className="bi bi-chat-dots"></i>
                <span className='ms-2'>Comentarios {`${commentsList?.length || 0}`}</span>
            </h5>
            <form onSubmit={handleNewComments}>
                <div className='p-comment-block-list'>
                    {commentsList?.map(it => (
                        <div key={it.id} className='p-comment-one d-flex justify-content-start align-items-center'>
                            <div className='d-flex justify-content-center align-items-center p-container-foto'>
                                <Tooltip title={`${it?.nombre}${' '}${it?.apellidos}`}>
                                    <span style={{ textTransform: 'uppercase' }}>
                                        {it?.nombre ? it.nombre.substring(0, 1) : ''}
                                        {it?.apellidos ? it.apellidos.substring(0, 1) : ''}
                                    </span>
                                </Tooltip>
                            </div>
                            <div>
                                <p className='mt-3 ms-3 block-obs-text'
                                    style={{ textAlign: 'justify', color: '#909090', fontSize: '14px' }}>
                                    {it.comentario}
                                </p>
                                <p className='d-flex justify-content-start align-items-center'>
                                    <div className='ms-3' style={{ fontSize: '11px', color: '#909090' }}>
                                        {moment(it.fecha_comentario).format('DD-MM-YYYY H:m')}
                                    </div>
                                    <div className='ms-3'>
                                        <Tooltip title="Eliminar comentario">
                                            <Link
                                                to="" onClick={() => handleRemoveComments(it.id)}
                                                style={{ color: 'rgb(142, 36, 170)', fontSize: '12px' }}
                                            >
                                                Eliminar
                                            </Link>
                                        </Tooltip>
                                    </div>
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
                <div className='p-comment-one d-flex justify-content-start align-items-center'>
                    <div className='d-flex justify-content-center align-items-center p-container-foto'>
                        {/* <Tooltip title={`${nameUser}${' '}${nameUser}`}>
                            <span>
                                {nameUser ? nameUser.substring(0, 1) : ''}
                                {nameUser ? nameUser.substring(0, 1) : ''}
                            </span>
                        </Tooltip> */}
                    </div>
                    <div className='mt-3 ms-3' style={{ width: '100%' }}>
                        <TextField
                            fullWidth
                            className='text-area-resize'
                            id="outlined-multiline-static"
                            name="input_comment"
                            label="Agrega un comentario..."
                            multiline
                            rows={3}
                            value={newComment || ''}
                            onChange={
                                ({ target }) => setNewComment(target.value)
                            }
                        />
                    </div>
                </div>
                <div className='text-end mt-2'>
                    <Button
                        style={{ width: 'auto' }}
                        className='p-btn-primary'
                        variant="contained"
                        size='medium'
                        type='submit'
                    >
                        {/* <i className="bi bi-send"></i> */}
                        <span className='ms-2'>Agregar comentario</span>
                    </Button>
                </div>
            </form>
        </div>
    )
}
